export enum HeartBeatStatusEnum {
  LOW_LATENCY = 'LOW_LATENCY',
  MEDIUM_LATENCY = 'MEDIUM_LATENCY',
  HIGH_LATENCY = 'HIGH_LATENCY',
  OFFLINE = 'OFFLINE',
}
